<template>
  <div class="tb-order-clean">
    <!-- 页面标题 -->
    <div class="page-header">
      <h1 class="page-title">淘宝订单清洗</h1>
      <p class="page-description">支持淘宝古德与京东订单清洗，校验规则保持一致</p>
    </div>
    <!-- 选项卡 -->
    <div class="tab-section">
      <el-tabs v-model="activeTab" type="card" class="clean-tabs">
        <!-- 美美哒订单清洗 -->
        <el-tab-pane label="美美哒订单清洗" name="mmd" disabled>
          <div class="form-section">
            <el-form :model="mmdForm" :rules="mmdRules" ref="mmdFormRef" label-width="120px">
              <!-- 店铺选择 -->
              <el-form-item label="清洗店铺" prop="shopName">
                <el-select v-model="mmdForm.shopName" placeholder="请选择店铺" style="width: 100%"
                  @change="handleMmdShopChange" filterable>
                  <el-option v-for="shop in validMmdShops" :key="shop.id" :label="shop.user_name"
                    :value="shop.user_name">
                    <span>{{ shop.user_name }}</span>
                    <el-tag v-if="isExpired(shop.expiration_time)" type="danger" size="small" style="margin-left: 8px">
                      已过期
                    </el-tag>
                  </el-option>
                </el-select>
              </el-form-item>

              <!-- 标题 -->
              <el-form-item label="任务标题" prop="title">
                <el-input v-model="mmdForm.title" placeholder="请输入完整任务标题" />
              </el-form-item>

              <!-- localTableName -->
              <el-form-item label="本地表名" prop="localTableName">
                <el-input v-model="mmdForm.localTableName" placeholder="请输入表名前缀">
                  <template #append>
                    <span>{{ mmdTableSuffix }}</span>
                  </template>
                </el-input>
              </el-form-item>

              <!-- 清洗时间 -->
              <el-form-item label="清洗时间" required>
                <el-col :span="11">
                  <el-form-item prop="startTime">
                    <el-date-picker v-model="mmdForm.startTime" type="datetime" placeholder="开始时间"
                      format="YYYY-MM-DD HH:mm:ss" value-format="YYYY-MM-DD HH:mm:ss" style="width: 100%" />
                  </el-form-item>
                </el-col>
                <el-col :span="2" class="text-center">-</el-col>
                <el-col :span="11">
                  <el-form-item prop="endTime">
                    <el-date-picker v-model="mmdForm.endTime" type="datetime" placeholder="结束时间"
                      format="YYYY-MM-DD HH:mm:ss" value-format="YYYY-MM-DD HH:mm:ss" style="width: 100%" />
                  </el-form-item>
                </el-col>
              </el-form-item>

              <!-- sessionKey -->
              <el-form-item label="sessionKey" prop="sessionKey">
                <el-input v-model="mmdForm.sessionKey" placeholder="请输入sessionKey" />
              </el-form-item>

              <!-- code -->
              <el-form-item label="项目Code" prop="code">
                <el-input v-model="mmdForm.code" placeholder="请输入项目Code" />
              </el-form-item>

              <!-- SQL -->
              <el-form-item label="SQL语句" prop="sql">
                <div class="sql-section">
                  <div class="sql-tip">SQL 需要包含 user_id 即可</div>
                  <div class="sql-editor-container">
                    <SqlEditor v-model="mmdForm.sql" :height="300" language="sql"
                      placeholder="请输入SQL语句，必须以select开头，以;结尾" />
                    <div class="sql-actions">
                      <el-button type="success" size="small" @click="copyMmdSqlDemo">
                        <el-icon>
                          <DocumentCopy />
                        </el-icon>
                        复制 SQL Demo
                      </el-button>
                    </div>
                  </div>
                </div>
              </el-form-item>

              <!-- 提交按钮 -->
              <el-form-item>
                <el-button type="primary" :loading="mmdLoading" @click="submitMmdForm" :disabled="!isMmdFormValid">
                  提交清洗任务
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>

        <!-- 古德订单清洗 -->
        <el-tab-pane label="古德订单清洗" name="tdz">
          <div class="form-header">
            <el-button type="primary" @click="showTdzOrderList">选择清洗订单</el-button>
          </div>
          <!-- 订单列表弹窗 -->
          <el-dialog v-model="showOrderList" title="古德订单清洗列表" width="90%" top="5vh" center append-to-body>
            <TdzCleanOrderList v-if="showOrderList" ref="tdzOrderListRef" />
          </el-dialog>
          <div class="form-section">
            <el-form :model="tdzForm" :rules="tdzRules" ref="tdzFormRef" label-width="120px">
              <!-- 店铺选择 -->
              <el-form-item label="清洗店铺" prop="shopName">
                <el-select v-model="tdzForm.shopName" placeholder="请选择店铺" style="width: 100%" filterable
                  @change="handleTdzShopChange">
                  <el-option v-for="shop in validTdzShops" :key="shop.id" :label="shop.user_name"
                    :value="shop.user_name">
                    <span>{{ shop.user_name }}</span>
                    <el-tag v-if="isExpired(shop.expiration_time)" type="danger" size="small" style="margin-left: 8px">
                      已过期
                    </el-tag>
                  </el-option>
                </el-select>
              </el-form-item>

              <!-- 业务ID -->
              <el-form-item label="business_id" prop="businessId">
                <el-input v-model="tdzForm.businessId" placeholder="请输入businessId,规则请写项目code" />
              </el-form-item>

              <!-- 业务编码 -->
              <el-form-item label="business_code" prop="businessCode">
                <el-input v-model="tdzForm.businessCode" placeholder="请输入businessCode,规则参考sql分区规则" />
              </el-form-item>

              <!-- 清洗日期 -->
              <el-form-item label="清洗日期" required>
                <el-col :span="11">
                  <el-form-item prop="startDay">
                    <el-date-picker v-model="tdzForm.startDay" type="date" placeholder="开始日期" format="YYYY-MM-DD"
                      value-format="YYYY-MM-DD" style="width: 100%" />
                  </el-form-item>
                </el-col>
                <el-col :span="2" class="text-center">-</el-col>
                <el-col :span="11">
                  <el-form-item prop="endDay">
                    <el-date-picker v-model="tdzForm.endDay" type="date" placeholder="结束日期" format="YYYY-MM-DD"
                      value-format="YYYY-MM-DD" style="width: 100%" />
                  </el-form-item>
                </el-col>
              </el-form-item>

              <!-- SQL -->
              <el-form-item label="SQL语句" prop="sql">
                <div class="sql-section">
                  <div class="sql-tip">SQL 需要包含
                    business_id、business_code、business_value、user_id、item_ids、first_visit_time
                    这五个字段，不需要的字段空字符串即可</div>
                  <div class="sql-tip">仅允许包含字母、数字和特定符号，包括空格、冒号（:）、下划线（_）、美元符号（$）、井号（#）、英文句点（.）、感叹号（!）和 at 符号（@）。</div>
                  <div class="sql-tip">分区值不能包含双字节字符（如中文）。必须以字母开头。不支持其他特殊字符，例如转义字符（\t、\n）和斜杠（/）。</div>
                  <div class="sql-tip">sql中不允许包含中文或者英文双引号 ""。</div>
                  <div class="sql-editor-container">
                    <SqlEditor v-model="tdzForm.sql" :height="300" language="sql"
                      placeholder="请输入SQL语句，必须以select开头，以;结尾" @change="handleTdzSqlChange" />
                    <div class="sql-actions">
                      <el-button type="success" size="small" @click="copyTdzSqlDemo">
                        <el-icon>
                          <DocumentCopy />
                        </el-icon>
                        复制 SQL Demo
                      </el-button>
                    </div>
                  </div>
                </div>
              </el-form-item>

              <!-- 提交按钮 -->
              <el-form-item>
                <el-button type="primary" :loading="tdzLoading" @click="submitTdzForm" :disabled="!isTdzFormValid">
                  提交清洗任务
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>

        <!-- 京东订单清洗 -->
        <el-tab-pane label="京东订单清洗" name="jd">
          <div class="form-header">
            <el-button type="primary" @click="showJdOrderList">选择清洗订单</el-button>
          </div>
          <el-dialog v-model="showJdOrderDialog" title="京东订单清洗列表" width="90%" top="5vh" center append-to-body>
            <TdzCleanOrderList v-if="showJdOrderDialog" ref="jdOrderListRef" />
          </el-dialog>
          <div class="form-section">
            <el-form :model="jdForm" :rules="tdzRules" ref="jdFormRef" label-width="120px">
              <el-form-item label="清洗店铺" prop="shopName">
                <el-select v-model="jdForm.shopName" placeholder="请选择店铺" style="width: 100%" filterable
                  @change="handleJdShopChange">
                  <el-option v-for="shop in jdShopOptions" :key="shop.id" :label="shop.shopName" :value="shop.shopName">
                    <span>{{ shop.shopName }}</span>
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="business_id" prop="businessId">
                <el-input v-model="jdForm.businessId" placeholder="请输入businessId,规则请写项目code" />
              </el-form-item>

              <el-form-item label="business_code" prop="businessCode">
                <el-input v-model="jdForm.businessCode" placeholder="请输入businessCode,规则参考sql分区规则" />
              </el-form-item>

              <el-form-item label="清洗日期" required>
                <el-col :span="11">
                  <el-form-item prop="startDay">
                    <el-date-picker v-model="jdForm.startDay" type="date" placeholder="开始日期" format="YYYY-MM-DD"
                      value-format="YYYY-MM-DD" style="width: 100%" />
                  </el-form-item>
                </el-col>
                <el-col :span="2" class="text-center">-</el-col>
                <el-col :span="11">
                  <el-form-item prop="endDay">
                    <el-date-picker v-model="jdForm.endDay" type="date" placeholder="结束日期" format="YYYY-MM-DD"
                      value-format="YYYY-MM-DD" style="width: 100%" />
                  </el-form-item>
                </el-col>
              </el-form-item>

              <el-form-item label="SQL语句" prop="sql">
                <div class="sql-section">
                  <div class="sql-tip">SQL 需要包含
                    business_id、business_code、business_value、user_id、item_ids、first_visit_time
                    这五个字段，不需要的字段空字符串即可</div>
                  <div class="sql-tip">仅允许包含字母、数字和特定符号，包括空格、冒号（:）、下划线（_）、美元符号（$）、井号（#）、英文句点（.）、感叹号（!）和 at 符号（@）。</div>
                  <div class="sql-tip">分区值不能包含双字节字符（如中文）。必须以字母开头。不支持其他特殊字符，例如转义字符（\t、\n）和斜杠（/）。</div>
                  <div class="sql-tip">sql中不允许包含中文或者英文双引号 ""。</div>
                  <div class="sql-editor-container">
                    <SqlEditor v-model="jdForm.sql" :height="300" language="sql" placeholder="请输入SQL语句，必须以select开头，以;结尾"
                      @change="handleJdSqlChange" />
                    <div class="sql-actions">
                      <el-button type="success" size="small" @click="copyTdzSqlDemo">
                        <el-icon>
                          <DocumentCopy />
                        </el-icon>
                        复制 SQL Demo
                      </el-button>
                    </div>
                  </div>
                </div>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" :loading="jdLoading" @click="submitJdForm" :disabled="!isJdFormValid">
                  提交清洗任务
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, nextTick } from 'vue'
import TdzCleanOrderList from '@/components/TdzCleanOrderList.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { DocumentCopy } from '@element-plus/icons-vue'
import { mmdShopNameList, tdzShopNameList, jdShopNameList } from '@/mock/TbOrderShopName.js'
import api from '@/utils/http.js'
import SqlEditor from '@/components/SqlEditor.vue'
import {
  saveTdzCleaningOrder
} from '../utils/restApi';

// 响应式数据
const activeTab = ref('tdz')

// 美美哒表单数据
const mmdForm = ref({
  shopName: '',
  title: '',
  localTableName: '',
  startTime: '',
  endTime: '',
  sessionKey: '',
  code: '',
  sql: ''
})

const mmdFormRef = ref()
const mmdLoading = ref(false)

// 古德表单数据
const tdzForm = ref({
  shopName: '',
  businessId: '',
  businessCode: '',
  startDay: '',
  endDay: '',
  sql: ''
})

const tdzFormRef = ref()
const tdzLoading = ref(false)
const tdzOrderListRef = ref(null)
const showOrderList = ref(false)

const jdForm = ref({
  shopName: '',
  businessId: '',
  businessCode: '',
  startDay: '',
  endDay: '',
  sql: ''
})

const jdFormRef = ref()
const jdLoading = ref(false)
const jdOrderListRef = ref(null)
const showJdOrderDialog = ref(false)

// SQL Demo 内容
const mmdSqlDemo = `SELECT DISTINCT(user_id) user_id FROM  mf_tracking_data_origin_record WHERE project_code = '2627' and custom_type IS NOT NULL AND custom_type != '' and t_timestamp >= TO_MILLIS(DATETIME '2024-03-08 00:00:00') and t_timestamp <= TO_MILLIS(DATETIME '2024-03-14 23:59:59');`

const tdzSqlDemo = `SELECT '2578' as business_id, 'jumpItem' as business_code, '214224' as business_value, user_id,SUBSTRING_INDEX(custom_type,'_',-1)  as item_ids, TO_CHAR(FROM_UNIXTIME((min(t_timestamp)) / 1000),'yyyy-mm-dd hh:mi:ss') as first_visit_time  FROM mf_tracking_data_origin_record  WHERE project_code = '2578'  and custom_type like ('%跳转商品%') and t_timestamp >= TO_MILLIS(DATETIME '2025-02-14 00:00:00')   and t_timestamp <= TO_MILLIS(DATETIME '2025-02-24 23:59:59')  GROUP BY user_id,item_ids;`

// 计算属性
// 美美哒标题前缀
const mmdTitlePrefix = computed(() => {
  const now = new Date()
  const year = now.getFullYear()
  const month = String(now.getMonth() + 1).padStart(2, '0')
  const day = String(now.getDate()).padStart(2, '0')
  const shopName = mmdForm.value.shopName || '店铺名称'
  return `${shopName}_${year}_${month}_${day}_`
})

// 美美哒表名后缀
const mmdTableSuffix = computed(() => {
  if (mmdForm.value.startTime && mmdForm.value.endTime) {
    const startSuffix = mmdForm.value.startTime.replace(/[-: ]/g, '').substring(0, 8)
    const endSuffix = mmdForm.value.endTime.replace(/[-: ]/g, '').substring(0, 8)
    return `_${startSuffix}_${endSuffix}`
  }
  return '_开始时间_结束时间'
})

// 古德标题
const tdzTitle = computed(() => {
  return buildOrderTitle(tdzForm.value)
})

const jdTitle = computed(() => {
  return buildOrderTitle(jdForm.value)
})

const buildOrderTitle = (form) => {
  const shopName = form.shopName || '店铺名称'
  const startDay = form.startDay || '开始时间'
  const endDay = form.endDay || '结束时间'
  //获取当前时间 年月日时分秒
  const now = new Date()
  const year = now.getFullYear()
  const month = String(now.getMonth() + 1).padStart(2, '0')
  const day = String(now.getDate()).padStart(2, '0')
  const hour = now.getHours()
  const minute = now.getMinutes()
  const second = now.getSeconds()
  const time = `${year}${month}${day}${hour}${minute}${second}`
  return `${shopName}_清洗订单_${startDay}_${endDay}_任务提交时间_${time}`
}

// 有效的店铺列表（排除过期店铺）
const validMmdShops = computed(() => {
  return mmdShopNameList.filter(shop => !isExpired(shop.expiration_time))
})

const validTdzShops = computed(() => {
  return tdzShopNameList.filter(shop => !isExpired(shop.expiration_time))
})

const jdShopOptions = computed(() => {
  return jdShopNameList
})

// 表单验证
const mmdRules = {
  shopName: [{ required: true, message: '请选择店铺', trigger: 'change' }],
  title: [{ required: true, message: '请输入完整任务标题', trigger: 'blur' }],
  localTableName: [{ required: true, message: '请输入表名前缀', trigger: 'blur' }],
  startTime: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
  endTime: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
  sessionKey: [{ required: true, message: '请输入sessionKey', trigger: 'blur' }],
  code: [{ required: true, message: '请输入项目Code', trigger: 'blur' }],
  sql: [
    { required: true, message: '请输入SQL语句', trigger: 'blur' },
    {
      validator: (rule, value, callback) => {
        if (!value) {
          callback(new Error('请输入SQL语句'))
        } else if (!value.trim().toLowerCase().startsWith('select')) {
          callback(new Error('SQL必须以select开头'))
        } else if (!value.trim().endsWith(';')) {
          callback(new Error('SQL必须以;结尾'))
        } else {
          callback()
        }
      },
      trigger: 'blur'
    }
  ]
}

const tdzRules = {
  shopName: [{ required: true, message: '请选择店铺', trigger: 'change' }],
  businessId: [
    { required: true, message: '请输入businessId', trigger: 'blur' },
    {
      validator: (rule, value, callback) => {
        if (!value) {
          callback(new Error('请输入业务ID'))
        } else if (!/^[a-zA-Z0-9_]+$/.test(value)) {
          callback(new Error('业务ID仅允许包含字母、数字、下划线'))
        } else {
          callback()
        }
      },
      trigger: 'blur'
    }
  ],
  businessCode: [
    { required: true, message: '请输入businessCode', trigger: 'blur' },
    {
      validator: (rule, value, callback) => {
        if (!value) {
          callback(new Error('请输入业务编码'))
        } else if (!/^[a-zA-Z]/.test(value)) {
          callback(new Error('业务编码必须以字母开头'))
        } else if (!/^[a-zA-Z0-9_]+$/.test(value)) {
          callback(new Error('业务编码仅允许包含字母、数字、下划线'))
        } else {
          callback()
        }
      },
      trigger: 'blur'
    }
  ],
  startDay: [{ required: true, message: '请选择开始日期', trigger: 'change' }],
  endDay: [{ required: true, message: '请选择结束日期', trigger: 'change' }],
}

// 表单验证状态
const isMmdFormValid = computed(() => {
  return mmdForm.value.shopName && mmdForm.value.title && mmdForm.value.localTableName &&
    mmdForm.value.startTime && mmdForm.value.endTime && mmdForm.value.sessionKey &&
    mmdForm.value.code && mmdForm.value.sql &&
    mmdForm.value.sql.trim().toLowerCase().startsWith('select') &&
    mmdForm.value.sql.trim().endsWith(';')
})

const isTdzFormValid = computed(() => {
  return isOrderCleanFormValid(tdzForm.value)
})

const isJdFormValid = computed(() => {
  return isOrderCleanFormValid(jdForm.value)
})

// 工具函数
// 检查是否过期
const isExpired = (expireTime) => {
  if (!expireTime) return true
  const expireDate = new Date(expireTime)
  const now = new Date()
  return expireDate < now
}

// 复制SQL Demo
const copySqlDemo = async (sql) => {
  try {
    await navigator.clipboard.writeText(sql)
    ElMessage.success('复制成功')
  } catch (error) {
    console.error('复制失败:', error)
    // 降级方案
    const textarea = document.createElement('textarea')
    textarea.value = sql
    document.body.appendChild(textarea)
    textarea.select()
    document.execCommand('copy')
    document.body.removeChild(textarea)
    ElMessage.success('复制成功')
  }
}

const copyMmdSqlDemo = () => {
  copySqlDemo(mmdSqlDemo)
}

const copyTdzSqlDemo = () => {
  copySqlDemo(tdzSqlDemo)
}

// 店铺选择变化时更新sessionKey
const handleMmdShopChange = (shopName) => {
  const shop = mmdShopNameList.find(s => s.user_name === shopName)
  if (shop) {
    mmdForm.value.sessionKey = shop.access_token || ''
  }
}

const handleTdzShopChange = (shopName) => {
  const shop = tdzShopNameList.find(s => s.user_name === shopName)
  if (shop) {
    // 古德不需要自动填充sessionKey
  }
}

const handleJdShopChange = (shopName) => {
  const shop = jdShopNameList.find(s => s.shopName === shopName)
  if (shop) {
    // 京东订单清洗与古德保持一致
  }
}


// 提交表单
const submitMmdForm = async () => {
  if (!mmdFormRef.value) return

  try {
    await mmdFormRef.value.validate()
    mmdLoading.value = true

    // 构建请求参数
    const params = {
      title: mmdForm.value.title,
      localTableName: `${mmdForm.value.localTableName}${mmdTableSuffix.value}`,
      startTime: mmdForm.value.startTime,
      endTime: mmdForm.value.endTime,
      appKey: '23067266',
      secret: '0bfebee04873d852dda5c7ec2d938f2e',
      sessionKey: mmdForm.value.sessionKey,
      code: mmdForm.value.code,
      sql: mmdForm.value.sql
    }

    // 使用封装的 http.js 调用接口
    const result = await api.post('/v3/admin/trade/pullTradeByCrowUser', params)

    if (result && result.code === 200) {
      ElMessage.success('提交成功')
      // 重置表单
      mmdFormRef.value.resetFields()
    } else {
      ElMessage.error(`提交失败: ${result?.errorMsg || '未知错误'}`)
    }
  } catch (error) {
    console.error('提交失败:', error)
    ElMessage.error('提交失败，请重试')
  } finally {
    mmdLoading.value = false
  }
}

const showTdzOrderList = () => {
  showOrderList.value = true
}

const showJdOrderList = () => {
  showJdOrderDialog.value = true
}

const submitTdzForm = async () => {
  return submitOrderCleanForm({
    formRef: tdzFormRef,
    form: tdzForm,
    loading: tdzLoading,
    title: tdzTitle.value,
    apiPath: '/tdzorder/api/v1/order/custom/push',
    cleanChannel: 'TB'
  })
}

const submitJdForm = async () => {
  return submitOrderCleanForm({
    formRef: jdFormRef,
    form: jdForm,
    loading: jdLoading,
    title: jdTitle.value,
    apiPath: '/jdorder/api/v1/order/custom/push',
    cleanChannel: 'JD'
  })
}

// 解析SQL中的business_id和business_code
const parseSelectFields = (sql) => {
  const result = {
    businessId: '',
    businessCode: ''
  }

  // 匹配 SELECT 子句（支持多行和各种格式）
  const selectMatch = sql.match(/select\s+([\s\S]*?)\s+from\s+/i)
  if (!selectMatch) return result

  const selectContent = selectMatch[1]

  // 解析 business_id（支持多种格式：AS、as、空格等）
  const businessIdPatterns = [
    /'([^']*)'\s+(?:AS|as)?\s*business_id/i,
    /'([^']*)'\s+["']?business_id["']?/i,
    /business_id\s*(?:AS|as)?\s*'([^']*)'/i
  ]

  for (const pattern of businessIdPatterns) {
    const match = selectContent.match(pattern)
    if (match) {
      result.businessId = match[1]
      break
    }
  }

  // 解析 business_code（支持多种格式：AS、as、空格等）
  const businessCodePatterns = [
    /'([^']*)'\s+(?:AS|as)?\s*business_code/i,
    /'([^']*)'\s+["']?business_code["']?/i,
    /business_code\s*(?:AS|as)?\s*'([^']*)'/i
  ]

  for (const pattern of businessCodePatterns) {
    const match = selectContent.match(pattern)
    if (match) {
      result.businessCode = match[1]
      break
    }
  }

  return result
}

// 解析时间范围
const parseTimeRange = (sql) => {
  const result = {
    startDay: '',
    endDay: ''
  }

  // 匹配开始时间 (>=, >)
  const startPatterns = [
    /t_timestamp\s*>=\s*TO_MILLIS\(DATETIME\s+'(\d{4}-\d{2}-\d{2})/i,
    /t_timestamp\s*>\s*TO_MILLIS\(DATETIME\s+'(\d{4}-\d{2}-\d{2})/i
  ]

  for (const pattern of startPatterns) {
    const match = sql.match(pattern)
    if (match) {
      result.startDay = match[1]
      break
    }
  }

  // 匹配结束时间 (<=, <)
  const endLessEqualMatch = sql.match(/t_timestamp\s*<=\s*TO_MILLIS\(DATETIME\s+'(\d{4}-\d{2}-\d{2})/i)
  const endLessMatch = sql.match(/t_timestamp\s*<\s*TO_MILLIS\(DATETIME\s+'(\d{4}-\d{2}-\d{2})/i)

  if (endLessEqualMatch) {
    // <= 操作符，直接使用该日期
    result.endDay = endLessEqualMatch[1]
  } else if (endLessMatch) {
    // < 操作符，需要减1天
    const date = new Date(endLessMatch[1])
    date.setDate(date.getDate() - 1)
    result.endDay = date.toISOString().split('T')[0]
  }

  return result
}

// 处理古德SQL变化
const handleTdzSqlChange = (sql) => {
  syncOrderCleanFormBySql(tdzForm.value, sql)
}

const handleJdSqlChange = (sql) => {
  syncOrderCleanFormBySql(jdForm.value, sql)
}

const syncOrderCleanFormBySql = (form, sql) => {
  // 如果SQL为空，清空所有解析的字段
  if (!sql.trim()) {
    if (form.businessId) form.businessId = ''
    if (form.businessCode) form.businessCode = ''
    if (form.startDay) form.startDay = ''
    if (form.endDay) form.endDay = ''
    return
  }

  // 只有当SQL以分号结尾时才进行解析
  if (!sql.trim().endsWith(';')) {
    return
  }

  // 解析SELECT字段
  const selectFields = parseSelectFields(sql)

  // 自动填充
  if (!form.businessId && selectFields.businessId) {
    form.businessId = selectFields.businessId
  }

  if (!form.businessCode && selectFields.businessCode) {
    form.businessCode = selectFields.businessCode
  }

  // 解析时间范围
  const timeRange = parseTimeRange(sql)

  if (!form.startDay && timeRange.startDay) {
    form.startDay = timeRange.startDay
  }

  if (!form.endDay && timeRange.endDay) {
    form.endDay = timeRange.endDay
  }
}

const isOrderCleanFormValid = (form) => {
  return form.shopName && form.businessId &&
    form.businessCode && form.startDay && form.endDay &&
    form.sql && form.sql.trim().toLowerCase().startsWith('select') &&
    form.sql.trim().endsWith(';') && !form.sql.trim().includes('"') && !form.sql.trim().includes('“') && !form.sql.trim().includes('”')
}

const submitOrderCleanForm = async ({ formRef, form, loading, title, apiPath, cleanChannel }) => {
  if (!formRef.value) return

  try {
    await formRef.value.validate()
    loading.value = true

    const params = {
      shopName: form.value.shopName,
      title,
      businessId: form.value.businessId,
      businessCode: form.value.businessCode,
      startDay: form.value.startDay,
      endDay: form.value.endDay,
      sql: form.value.sql,
      cleanChannel
    }

    try {
      const result = await api.post(apiPath, params)
      const successMatched = typeof result?.success === 'boolean' ? result.success : true

      if (result && result.code === 200 && successMatched) {
        await saveTdzCleaningOrder(params)
        let msg = `提交成功: ${result.errorMsg || result.message || '订单清洗任务已提交'}`
        ElMessage.success(msg)
        formRef.value.resetFields()
      } else {
        ElMessage.error(`提交失败: ${result?.message || result?.errorMsg || '未知错误'}`)
      }
    } catch (apiError) {
      console.error('接口调用失败:', apiError)
      ElMessage.error('提交失败，请检查网络连接或接口配置')
    }
  } catch (error) {
    console.error('提交失败:', error)
    ElMessage.error('提交失败，请重试')
  } finally {
    loading.value = false
  }
}

// 页面加载时初始化
onMounted(() => {
  // 监听店铺选择变化
  mmdForm.value.shopName && handleMmdShopChange(mmdForm.value.shopName)
  tdzForm.value.shopName && handleTdzShopChange(tdzForm.value.shopName)
  jdForm.value.shopName && handleJdShopChange(jdForm.value.shopName)
})
</script>

<style scoped>
.tb-order-clean {
  max-width: 1000px;
  margin: 0 auto;
  padding: 24px;
  min-height: calc(100vh - 120px);
}

/* 页面标题样式 */
.page-header {
  text-align: center;
  margin-bottom: 32px;
}

.page-title {
  font-size: 2.5rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 8px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.page-description {
  font-size: 1.1rem;
  color: #6b7280;
  margin: 0;
}

/* 选项卡样式 */
.tab-section {
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.clean-tabs {
  padding: 24px;
}

/* 表单区域样式 */
.form-section {
  padding: 20px 0;
}

.sql-section {
  width: 100%;
  position: relative;
}

.sql-tip {
  font-size: 12px;
  color: #909399;
  margin-bottom: 8px;
  padding: 4px 8px;
  background: #f5f7fa;
  border-radius: 4px;
}

.sql-actions {
  margin-top: 8px;
  text-align: right;
}

.text-center {
  text-align: center;
  line-height: 40px;
}

/* SQL 编辑器样式优化 */
.sql-editor-container {
  position: relative;
}

.sql-textarea {
  font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
  font-size: 14px;
  line-height: 1.5;
}

.sql-textarea :deep(.el-textarea__inner) {
  font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
  font-size: 14px;
  line-height: 1.5;
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.sql-textarea :deep(.el-textarea__inner):focus {
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
  background-color: #fff;
}

.sql-textarea :deep(.el-textarea__inner):hover {
  border-color: #c0c4cc;
}

/* SQL 操作按钮样式 */
.sql-actions {
  margin-top: 8px;
  text-align: right;
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.sql-actions .el-button {
  border-radius: 4px;
  font-weight: 500;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .tb-order-clean {
    padding: 16px;
  }

  .page-title {
    font-size: 2rem;
  }

  .clean-tabs {
    padding: 16px;
  }

  .form-section {
    padding: 16px 0;
  }

  .sql-actions {
    flex-direction: column;
    gap: 6px;
  }

  .sql-actions .el-button {
    width: 100%;
  }
}
</style>
